import React from 'react';
import  Science2025  from 'views/Science2025';

const BlogNewsroomPage = () => {

return <Science2025/>
};

export default BlogNewsroomPage;